import { z } from 'zod';

import { schemaConsorsEmail } from './email.schema';
import { schemaConsorsTelephone } from './telephone.schema';

export const schemaConsorsContactAddressBasic = z.object({
    email: schemaConsorsEmail.optional(),
    telephoneLandline: schemaConsorsTelephone.optional(),
    telephoneMobile: schemaConsorsTelephone.optional(),
});
